/* eslint-disable import/prefer-default-export */
import router from '@/router'

export const isPdvRoute = () => router.currentRoute.path.startsWith('/pdv/')
